<script setup lang="ts">
import { ArrowDown, ArrowUp, Globe } from "lucide-vue-next";
const showUpperContent = ref(true);
</script>
<template>
	<div v-if="showUpperContent" class="tw:flex tw:flex-col">
		<header class="tw:flex tw:items-center tw:justify-between tw:p-5">
			<div class="tw:flex tw:gap-1 tw:flex-grow">
				<slot name="prepend-title" />
				<slot name="title" />
			</div>
			<div>
				<slot name="append" />
			</div>
		</header>
		<div class="tw:max-h-[70vh]">
			<slot name="content" />
		</div>
	</div>
	<footer
		class="tw:bg-[--default-background-color] tw:flex tw:px-4 tw:mb-4 tw:justify-between tw:items-center
			tw:mt-auto tw:overflow-hidden tw:gap-x-2">
		<div class="tw:flex tw:items-center tw:gap-1 tw:w-full">
			<slot name="footer-left">
				<Globe stroke-width="3" :size="15" class="tw:!mt-0.5" />
				<p class="tw:text-[max(14px,0.9vmax)] tw:max-sm:hidden">Social</p>
				<div class="tw:ml-auto">
					<ArrowDown
						v-if="showUpperContent"
						class="tw:cursor-pointer"
						@click="showUpperContent = !showUpperContent"
						:size="20" />
					<ArrowUp
						class="tw:cursor-pointer"
						v-else
						@click="showUpperContent = !showUpperContent"
						:size="20" />
				</div>
			</slot>
		</div>
	</footer>
</template>
